module.exports = "@import &#x27;../../variables&#x27;; .DesiredBudgetPane { display: flex; flex-direction: row; margin-left: 40px; align-items: center; @include mobile { margin-left: 0; margin-top: 30px; } &amp;-label { color: #7d7d7d; margin-right: 10px; } &amp;-input { width: 150px; } &amp;--hide { visibility: hidden; @include mobile { display: none; } } }"


//////////////////
// WEBPACK FOOTER
// ./~/svg-inline-loader!./client/components/ParametersScreen/DesiredBudgetPane/DesiredBudgetPane.scss
// module id = 2022
// module chunks = 0